const { Currency } = require('@sigmasms/shared-types')
const { upgradeArray } = require('../utils')
const enumToConstant = require('../utils/enumToConstant')

const BILLING_STATUS = upgradeArray([ 'pending', 'refunded', 'complete', 'invalid' ])

const BILLING_CURRENCY = enumToConstant(Currency)

module.exports = {
  BILLING_STATUS,
  BILLING_CURRENCY
}
